<template>

  <div>
      <!-- <template v-slot:activator="{ on, attrs }">
        
      </template> -->

    <v-row align="center" justify="center">
      <v-col cols="12" xl="12" class="pt-0">
        <v-card class="mx-auto">
          
            <v-card width="100%" color="grey lighten-4" elevation="0" light>
              <v-card-title class="pl-12 py-10">
                <div class="display-1">
                    {{profileData.name}}
                </div>
              </v-card-title>
              <v-divider></v-divider>
            </v-card>

          <v-list two-line>
            <v-list-item>
              
              <v-list-item-icon>
              <v-icon color="indigo">
                  mdi-phone
              </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
              <v-list-item-title >{{profileData.gsm}}</v-list-item-title>
              <v-list-item-subtitle>GSM</v-list-item-subtitle>
              </v-list-item-content>

                <!-- <v-list-item-icon>
                <v-icon>mdi-message-text</v-icon>
                </v-list-item-icon> -->
            </v-list-item>

            <v-list-item>
              <v-list-item-action></v-list-item-action>

              <v-list-item-content>
              <v-list-item-title>{{profileData.tel}}</v-list-item-title>
              <v-list-item-subtitle>İş</v-list-item-subtitle>
              </v-list-item-content>

                <!-- <v-list-item-icon>
                <v-icon>mdi-message-text</v-icon>
                </v-list-item-icon> -->
            </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item>
              <v-list-item-icon>
              <v-icon color="indigo">
                  mdi-email
              </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
              <v-list-item-title>{{profileData.email}}</v-list-item-title>
              <v-list-item-subtitle>E-posta</v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item>
<!-- 
          <v-list-item>
              <v-list-item-action></v-list-item-action>

              <v-list-item-content>
              <v-list-item-title>ali_connors@example.com</v-list-item-title>
              <v-list-item-subtitle>Work</v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item> -->

          <v-divider inset></v-divider>

          <v-list-item>
              <v-list-item-icon>
              <v-icon color="indigo">
                  mdi-map-marker
              </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
              <v-list-item-title>{{profileData.adress}}</v-list-item-title>
              <v-list-item-subtitle>Adres Bilgisi</v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
      
  </div>
</template>

<script>
export default {
    name: 'ViewProfile',
    props: {
        userdata: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            profileData: this.userdata,
            openViewProfile: false,
        }
    }
}
</script>